var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdresse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 11 Copy 11@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-3",
    cx: 32,
    cy: 32,
    r: 32
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-5",
    x: 0,
    y: 0,
    width: 35.4,
    height: 35.4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GDPR-Personopplysning-forside",
    transform: "translate(-590.000000, -1874.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11-Copy-11",
    transform: "translate(590.000000, 1874.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "spotlight/-gjenstand-"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }), /*#__PURE__*/React.createElement("g", {
    id: "spotlight/-element",
    mask: "url(#mask-2)",
    fillRule: "evenodd",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDF08-60"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "NAV-Brand/farge/-Dyp-bl\\xE5/-60",
    mask: "url(#mask-4)",
    fill: "#99C2E8"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    points: "0 64 64 64 64 0 0 0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Color/26-places/home-1",
    transform: "translate(14.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1991105,10.0735546 C28.3271199,10.2002408 28.4977991,10.2682513 28.6711452,10.2682513 C29.0378388,10.2682513 29.3378608,9.96953851 29.3378608,9.60148171 L29.3378608,3.60055564 C29.3378608,3.23249884 29.0391722,2.93378608 28.6711452,2.93378608 L22.6707048,2.93378608 C22.4013517,2.93378608 22.1573338,3.09647785 22.0546596,3.34584967 C21.9506519,3.59388795 22.0079895,3.88059886 22.1986702,4.07129495 L28.1991105,10.0735546 Z",
    id: "Fill/home-1",
    fill: "#3E3832",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#C86151",
    mask: "url(#mask-6)",
    points: "2.93378608 13.604337 2.93378608 35.2054329 32.2716469 35.2054329 32.2716469 13.604337 17.6027165 -5.32907052e-14"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    mask: "url(#mask-6)",
    x: 11.6129032,
    y: 16.2580645,
    width: 4.64516129,
    height: 4.64516129
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    fill: "#FFFFFF",
    mask: "url(#mask-6)",
    x: 11.6129032,
    y: 23.2258065,
    width: 4.64516129,
    height: 4.64516129
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "#FFFFFF",
    mask: "url(#mask-6)",
    x: 18.5806452,
    y: 16.2580645,
    width: 4.64516129,
    height: 4.64516129
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    fill: "#FFFFFF",
    mask: "url(#mask-6)",
    x: 18.5806452,
    y: 23.2258065,
    width: 4.64516129,
    height: 4.64516129
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0038557,15.0571629 C34.9979885,15.0532888 34.9950549,15.042958 34.9891878,15.0365012 L18.1210716,0.18595467 C17.8409142,-0.06198489 17.3642066,-0.06198489 17.0840492,0.18595467 L0.215933083,15.0365012 C-0.0495563966,15.2702359 -0.087693007,15.6550588 0.199798363,15.9288254 C0.532760308,16.2219622 0.980132083,16.1793476 1.24268798,15.9533611 C1.24562156,15.9520697 1.25002194,15.9507783 1.25295553,15.949487 L17.6032938,1.55607901 L33.9521653,15.9507783 C33.9550989,15.9520697 33.9580325,15.9533611 33.9609661,15.9546524 C34.2396567,16.1935525 34.7016964,16.1935525 34.9789202,15.9546524 C34.9818538,15.9533611 34.9862542,15.9520697 34.9891878,15.9507783 C35.256144,15.7157523 35.2928139,15.325764 35.0038557,15.0571629 Z",
    id: "Path",
    fill: "#3E3832",
    mask: "url(#mask-6)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdresse);
export default __webpack_public_path__ + "static/media/Adresse.61d28bac9bc65be9d05ab94d61aaa860.svg";
export { ForwardRef as ReactComponent };